import { render, staticRenderFns } from "./Tippings.vue?vue&type=template&id=afcfa0c6&scoped=true&"
import script from "./Tippings.vue?vue&type=script&lang=js&"
export * from "./Tippings.vue?vue&type=script&lang=js&"
import style0 from "./Tippings.vue?vue&type=style&index=0&id=afcfa0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcfa0c6",
  null
  
)

export default component.exports